import list from './list';
import switching from './switching';
import userInfo from './userInfo';

export default {
    /** 公司列表 */
    list,

    /** 切换公司 */
    switching,

    /** 获取用户数据 */
    userInfo,
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/company/index.ts